import React from 'react';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName?: string;
  userRole?: string;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userName = 'User',
  userRole = 'User',
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      id="logout-modal-overlay"
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-[10000] p-5 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div id="logout-modal-content" className="bg-white rounded-2xl shadow-2xl max-w-md w-full min-w-[320px] overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-4 p-6 border-b border-slate-200 bg-gradient-to-br from-slate-50 to-slate-100">
          <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-2xl">🚪</div>
          <h3 className="text-xl font-bold text-slate-800 m-0">Confirm Logout</h3>
        </div>
        <div className="p-6">
          <p className="text-slate-600 m-0 mb-3">Are you sure you want to logout?</p>
          <div className="flex flex-wrap items-baseline gap-2 mb-3">
            <span className="font-semibold text-slate-800">{userName}</span>
            <span className="text-slate-500 text-sm">({userRole})</span>
          </div>
          <p className="text-sm text-amber-700 m-0">You will be redirected to the login page and will need to sign in again.</p>
        </div>
        <div className="flex gap-3 p-6 pt-0 justify-end border-t border-slate-200">
          <button
            type="button"
            className="flex items-center gap-2 py-2.5 px-5 rounded-lg font-semibold text-sm bg-slate-100 text-slate-700 border-2 border-slate-200 cursor-pointer hover:bg-slate-200 transition-colors"
            onClick={onClose}
          >
            <span>❌</span> Cancel
          </button>
          <button
            type="button"
            className="flex items-center gap-2 py-2.5 px-5 rounded-lg font-semibold text-sm bg-gradient-to-r from-red-500 to-red-600 text-white border-none cursor-pointer hover:-translate-y-0.5 hover:shadow-lg transition-all"
            onClick={onConfirm}
          >
            <span>🚪</span> Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
